import { Validators } from "@angular/forms";
import { IColumnConfigTableResponsive } from "src/app/domain/IColumnConfigTableResponsive";
import { IFieldConfig } from "src/app/domain/IFieldConfig";
import { FieldTypeEnum } from "src/app/domain/registration/enums/field-type.enum";
import { SlipStatusEnum } from "src/app/domain/registration/enums/slip-status.enum";
import { TypeComponentFieldEnum } from "src/app/domain/registration/enums/type-component-dynamic.enum";
import { PeopleTypeEnum } from "src/app/domain/registration/enums/type-people.enum";
import { ButtonConfig } from "src/app/domain/registration/models/ButtonConfig";

export const RELATIVE_URL = 'merchants';

export enum tipoContaEnum {
    LIQUIDACAO = 'liquidacao',
    PAGAMENTO = 'pagamento'
};
export const COLUMNS_TO_SHOW_WEB = [
    'select',
    'externalId',
    'merchantName',
    'personType',
    'email',
    'pixKey',
    'documentNumber',
    'city',
    'financialPhone',
    'createdAt',
    'actions'
];

export const COLUMNS_TO_SHOW_MOBILE = [
    'select',
    'externalId',
    'merchantName',
    'personType',
    'email',
    'pixKey',
    'documentNumber',
    'city',
    'financialPhone',
    'createdAt',
    'actions'
];

export const TABLE_CONFIG_COLUMNS: IColumnConfigTableResponsive[] = [
    {
        property: 'canviId',
        field_type: FieldTypeEnum.LABEL,
        display: 'Código',
        class: 'text-left',
        maxLength: 20
    },

    {
        property: 'externalId',
        field_type: FieldTypeEnum.LABEL,
        display: 'Código Externo',
        class: 'text-left',
        maxLength: 20
    },

    {
        property: 'merchantName',
        field_type: FieldTypeEnum.LABEL,
        display: 'Nome',
        class: 'text-left',
        maxLength: 30
    },

    {
        property: 'personType',
        field_type: FieldTypeEnum.LABEL,
        display: 'Tipo de Pessoa',
        class: 'text-left',
        maxLength: 20
    },

    {
        property: 'email',
        field_type: FieldTypeEnum.LABEL,
        display: 'E-mail',
        class: 'text-left',
        maxLength: 30
    },

    {
        property: 'pixKey',
        field_type: FieldTypeEnum.LABEL,
        display: 'Chave PIX',
        class: 'text-left',
        maxLength: 30
    },

    {
        property: 'documentNumber',
        field_type: FieldTypeEnum.LABEL,
        display: 'CNPJ',
        class: 'text-left',
        maxLength: 20
    },

    {
        property: 'numeroCpf',
        field_type: FieldTypeEnum.LABEL,
        display: 'CPF',
        class: 'text-left',
        maxLength: 20
    },

    {
        property: 'city',
        field_type: FieldTypeEnum.LABEL,
        display: 'Cidade',
        class: 'text-left',
        maxLength: 20
    },

    {
        property: 'financialPhone',
        field_type: FieldTypeEnum.LABEL,
        display: 'Celular Financeiro',
        class: 'text-left',
        maxLength: 20
    },

    {
        property: 'createdAt',
        field_type: FieldTypeEnum.LABEL_DATE,
        display: 'Data de Criação',
        class: 'text-center',
    }
];

export const MERCHANT_CONFIG_FIELDS: IFieldConfig[] = [
    {
        type: TypeComponentFieldEnum.SELECT,
        label: 'Tipo de Pessoa',
        name: 'tipoPessoa',
        placeholder: 'Selecione o tipo de pessoa',
        validation: [Validators.required],
        options: Object.values(PeopleTypeEnum),
    },

    {
        type: TypeComponentFieldEnum.INPUT_CNPJ,
        label: 'CNPJ',
        name: 'numeroCnpj',
        placeholder: '00.000.000/0000-00',
        validation: [Validators.required, Validators.pattern(/^\d{14}$/)]
    },

    {
        type: TypeComponentFieldEnum.INPUT_CPF,
        label: 'CPF',
        name: 'numeroCpf',
        placeholder: '000.000.000-00',
        validation: [Validators.required, Validators.pattern(/^\d{11}$/)]
    },

    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'Nome/Razão Social',
        name: 'nomeComerciante',
        placeholder: 'Nome completo ou razão social',
        validation: [Validators.required]
    },

    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'Nome Social/Nome Fantasia',
        name: 'nomeSocial',
        placeholder: 'Nome social ou nome fantasia',
        validation: [Validators.required]
    },

    {
        type: TypeComponentFieldEnum.INPUT_DATE,
        label: 'Data de Nascimento/Fundação',
        name: 'dataNascimento',
        placeholder: 'dd/mm/aaaa',
        validation: [Validators.required]
    },

    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'Inscrição Estadual',
        name: 'inscricaoEstadual',
        placeholder: 'Inscrição estadual (obrigatória para PJ)',
        validation: [],
    },

    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'Inscrição Municipal',
        name: 'inscricaoMunicipal',
        placeholder: 'Inscrição municipal (opcional)',
        validation: []
    },

    {
        type: TypeComponentFieldEnum.INPUT_EMAIL,
        label: 'E-mail',
        name: 'email',
        placeholder: 'contato@exemplo.com.br',
        validation: [Validators.required, Validators.email]
    },

    // Dados Financeiros
    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'Chave PIX',
        name: 'chavePix',
        placeholder: 'Chave PIX',
        validation: []
    },

    {
        type: TypeComponentFieldEnum.INPUT_CELLPHONE,
        label: 'Celular Financeiro',
        name: 'celularFinanceiro',
        placeholder: '(11) 91234-5678',
        validation: [Validators.required, Validators.pattern(/^\d{11}$/)]
    },

    {
        type: TypeComponentFieldEnum.INPUT_EMAIL,
        label: 'E-mail Financeiro',
        name: 'emailFinanceiro',
        placeholder: 'financeiro@exemplo.com.br',
        validation: [Validators.required, Validators.email]
    },

    // Endereço Geral
    {
        type: TypeComponentFieldEnum.INPUT_CEP,
        label: 'CEP',
        name: 'cep',
        placeholder: '00000-000',
        validation: [Validators.required, Validators.pattern(/^\d{8}$/)]
    },

    {
        type: TypeComponentFieldEnum.SELECT,
        label: 'Estado',
        name: 'estado',
        placeholder: 'Selecione o estado',
        validation: [Validators.required],
        options: [],
        fallbackType: TypeComponentFieldEnum.INPUT,
        fallbackLabel: 'Estado',
        fallbackPlaceholder: 'Digite o estado'
    },

    {
        type: TypeComponentFieldEnum.SELECT,
        label: 'Cidade',
        name: 'cidade',
        placeholder: 'Selecione a cidade',
        validation: [Validators.required],
        options: [],
        fallbackType: TypeComponentFieldEnum.INPUT,
        fallbackLabel: 'Cidade',
        fallbackPlaceholder: 'Digite a cidade'
    },

    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'Endereço',
        name: 'endereco',
        placeholder: 'Rua, Avenida, etc.',
        validation: [Validators.required]
    },

    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'Número',
        name: 'numero',
        placeholder: 'Número',
        validation: [Validators.required]
    },

    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'Bairro',
        name: 'bairro',
        placeholder: 'Bairro',
        validation: [Validators.required]
    },

    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'Complemento',
        name: 'complemento',
        placeholder: 'Sala, Apto, etc. (opcional)',
        validation: []
    },

    // Responsável
    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'Nome do Responsável',
        name: 'responsavelNome',
        placeholder: 'Nome completo do responsável',
        validation: [Validators.required]
    },

    {
        type: TypeComponentFieldEnum.INPUT_CPF,
        label: 'CPF do Responsável',
        name: 'responsavelCpf',
        placeholder: '000.000.000-00',
        validation: [Validators.required, Validators.pattern(/^\d{11}$/)]
    },

    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'RG do Responsável',
        name: 'responsavelRg',
        placeholder: 'Registro Geral',
        validation: [Validators.required]
    },

    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'Nacionalidade',
        name: 'responsavelNacionalidade',
        placeholder: 'Nacionalidade',
        validation: [Validators.required],
        defaultValue: 'Brasileiro'
    },

    {
        type: TypeComponentFieldEnum.INPUT_CELLPHONE,
        label: 'Celular do Responsável',
        name: 'responsavelCelular',
        placeholder: '+55 11 99876-5432',
        validation: [Validators.required, Validators.pattern(/^\d{11}$/)]
    },

    {
        type: TypeComponentFieldEnum.INPUT_EMAIL,
        label: 'E-mail do Responsável',
        name: 'responsavelEmail',
        placeholder: 'responsavel@exemplo.com.br',
        validation: [Validators.required, Validators.email]
    },

    {
        type: TypeComponentFieldEnum.INPUT_DATE,
        label: 'Data de Nascimento do Responsável',
        name: 'responsavelDataNascimento',
        placeholder: 'dd/mm/aaaa',
        validation: [Validators.required]
    },

    // Endereço do Responsável
    {
        type: TypeComponentFieldEnum.INPUT_CEP,
        label: 'CEP do Responsável',
        name: 'responsavelCep',
        placeholder: '00000-000',
        validation: [Validators.required, Validators.pattern(/^\d{8}$/)]
    },

    {
        type: TypeComponentFieldEnum.SELECT,
        label: 'Estado do Responsável',
        name: 'responsavelEstado',
        placeholder: 'Selecione o estado',
        validation: [Validators.required],
        options: [],
        fallbackType: TypeComponentFieldEnum.INPUT,
        fallbackLabel: 'Estado do Responsável',
        fallbackPlaceholder: 'Digite o estado'
    },

    {
        type: TypeComponentFieldEnum.SELECT,
        label: 'Cidade do Responsável',
        name: 'responsavelCidade',
        placeholder: 'Selecione a cidade',
        validation: [Validators.required],
        options: [],
        fallbackType: TypeComponentFieldEnum.INPUT,
        fallbackLabel: 'Cidade do Responsável',
        fallbackPlaceholder: 'Digite a cidade'
    },

    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'Endereço do Responsável',
        name: 'responsavelEndereco',
        placeholder: 'Rua, Avenida, etc.',
        validation: [Validators.required]
    },

    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'Número do Responsável',
        name: 'responsavelNumero',
        placeholder: 'Número',
        validation: [Validators.required]
    },

    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'Bairro do Responsável',
        name: 'responsavelBairro',
        placeholder: 'Bairro',
        validation: [Validators.required]
    },

    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'Complemento do Responsável',
        name: 'responsavelComplemento',
        placeholder: 'Sala, Apto, etc. (opcional)',
        validation: []
    },

    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'ID Externo',
        name: 'idExterno',
        placeholder: 'Identificador externo único Ex:123456',
        validation: [Validators.required]
    },

    {
        type: TypeComponentFieldEnum.SELECT,
        label: 'Tipo de Conta',
        name: 'tipoConta',
        placeholder: 'Selecione o tipo de conta',
        validation: [Validators.required],
        options: Object.values(tipoContaEnum)
    },

    {
        type: TypeComponentFieldEnum.SLIDE_TOGGLE,
        label: 'Validar IP',
        name: 'validarIp',
        validation: []
    },

    {
        type: TypeComponentFieldEnum.INPUT,
        label: 'IPs Permitidos',
        name: 'ips',
        placeholder: '192.168.0.1, 192.168.0.2',
        validation: []
    }

];

export const FILTER_CONFIG: IFieldConfig[] = [
    {
        name: 'name',
        label: 'Nome',
        type: TypeComponentFieldEnum.INPUT,
        options: []
    },
    {
        name: 'document',
        label: 'Documento',
        type: TypeComponentFieldEnum.INPUT,
        options: []
    },
    {
        name: 'externalCode',
        label: 'Código Externo',
        type: TypeComponentFieldEnum.INPUT,
        options: []
    },
    {
        name: 'startDate',
        label: 'Data Inicial',
        type: TypeComponentFieldEnum.INPUT_DATE
    },
    {
        name: 'endDate',
        label: 'Data Final',
        type: TypeComponentFieldEnum.INPUT_DATE
    },
];

export const TABLE_BUTTONS: ButtonConfig[] = [
    {
        icon: 'receipt_long',
        tooltip: 'Transações',
        class: 'btn-transactions',
        action: 'transaction',
        isVisible: (element: any) => element.canviId
    },

    {
        icon: 'price_change',
        tooltip: 'Visualizar Tarifas',
        class: 'btn-price',
        action: 'fees',
        isVisible: (element: any) => element.canviId
    },

    {
        icon: 'pix',
        tooltip: 'Gerenciar Chaves PIX',
        class: 'btn-pix-keys',
        action: 'pixKeys'
    },

];

export interface MerchantFilter {
  name?: string;
  document?: string;
  externalCode?: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  limit?:number;
}
